import { useCallback, useState } from 'react';
import { AText } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';

import styles from './index.module.css';

const PepInfoLabel = () => {
  const { t } = useI18n();
  const [showAllPepInfo, setShowAllPepInfo] = useState(false);

  const onClick = useCallback(() => {
    setShowAllPepInfo(!showAllPepInfo);
  }, [showAllPepInfo]);

  return showAllPepInfo ? (
    <AText color="txt_color_7" size="s" component="span">
      {t('personalOffice.profile.data.pepInfo')}
    </AText>
  ) : (
    <AText color="txt_color_7" size="s" component="span">
      {`${t('personalOffice.profile.data.cutPepInfo')} `}

      <AText
        color="txt_link"
        size="s"
        component="span"
        className={styles.showMore}
        onClick={onClick}
      >
        {t('personalOffice.profile.data.pepInfo.showMore')}
      </AText>
    </AText>
  );
};

export default PepInfoLabel;
